import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 408,
  name: 'Request Timeout',
  description:
    'The server timed out waiting for the client to finish sending the request. The client opened a connection but did not complete the request within the server\'s timeout window.',
  causes: [
    'The client\'s network connection is slow or unstable, causing the request to take too long to transmit.',
    'A large file upload exceeds the server\'s timeout for receiving the request body.',
    'The client opened a keep-alive connection but did not send a follow-up request within the idle timeout period.',
  ],
  fixes: [
    'Check your network connection. Retry the request on a stable connection. If uploading large files, consider chunked uploads.',
    'Increase the server\'s client_body_timeout (nginx) or Timeout (Apache) if legitimate requests need more time.',
    'If this happens on keep-alive connections, adjust the keep-alive timeout settings or ensure your client sends requests promptly after opening a connection.',
  ],
  monitoringTip:
    'Frequent 408 errors suggest your server\'s timeout is too aggressive or clients have connectivity issues. Uptrack tracks response codes over time so you can spot patterns and adjust timeouts.',
}

export const Route = createFileRoute('/_site/http/408')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
